module.exports = __webpack_public_path__ + "img/sink.b7f6159b.svg";